<!-- Don't put large UI in here because it takes up screen real estate. -->
<!-- The order of these banners matters, they will be rendered in the order shown. Only rarely will multiple banners be shown at once-->
<special-info-quick-start />
<special-info-webinar />
<special-info-kyc-kyb-no-wave scope="KYC" />
<special-info-kyc-kyb-no-wave scope="KYB" />
<special-info-kyc-kyb-with-wave scope="KYC" />
<special-info-kyc-kyb-with-wave scope="KYB" />
<special-info-kyc-kyb-re-verification scope="KYC" />
<special-info-kyc-kyb-re-verification scope="KYB" />
<special-info-payroll-contact-setup />
